function splitModelUrl(url: string): { rootUrl: string; filename: string } {
  const index = url.lastIndexOf("/");

  return {
    rootUrl: url.slice(0, index + 1),
    filename: url.slice(index + 1),
  };
}

export async function loadInvivoModel({
  scene,
  modelUrl,
  workspaceRoot,
}: {
  scene: unknown;
  modelUrl: string;
  workspaceRoot: {
    setParent(parent: unknown): void;
  };
}): Promise<
  Array<{
    name?: string;
    parent?: unknown | null;
    position?: { x: number; y: number; z: number };
    scaling?: { x: number; y: number; z: number };
    rotation?: { x: number; y: number; z: number };
    material?: unknown;
    setParent(parent: unknown): void;
    setEnabled?(visible: boolean): void;
    getVerticesData?(kind: string): number[] | Float32Array | null | undefined;
    updateVerticesData?(kind: string, data: number[] | Float32Array): void;
  }>
> {
  const { BABYLON } = window;
  const { rootUrl, filename } = splitModelUrl(modelUrl);
  const result = await BABYLON.SceneLoader.ImportMeshAsync("", rootUrl, filename, scene, undefined, ".glb");

  result.meshes.forEach((mesh) => {
    if (mesh.parent == null) {
      mesh.setEnabled?.(true);
      mesh.setParent(workspaceRoot);
    }
  });

  return result.meshes as Array<{
    name?: string;
    parent?: unknown | null;
    position?: { x: number; y: number; z: number };
    scaling?: { x: number; y: number; z: number };
    rotation?: { x: number; y: number; z: number };
    material?: unknown;
    setParent(parent: unknown): void;
    setEnabled?(visible: boolean): void;
    getVerticesData?(kind: string): number[] | Float32Array | null | undefined;
    updateVerticesData?(kind: string, data: number[] | Float32Array): void;
  }>;
}
